import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { setGlobalSnackbar } from '../utils/axios';

/**
 * Component to setup global notification system
 * This component initializes the global snackbar for axios interceptors
 */
function GlobalNotificationSetup({ children }) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    // Set the global snackbar function for axios interceptors
    setGlobalSnackbar(enqueueSnackbar);
    
    // Cleanup on unmount (optional)
    return () => {
      setGlobalSnackbar(null);
    };
  }, [enqueueSnackbar]);

  return children;
}

export default GlobalNotificationSetup;
